import React from "react";
import "./MaterialButton.css";

const MaterialButton = ({ 
    children,
    type = "button", 
    variant = "primary", 
    size = "medium",
    disabled = false,
    loading = false,
    icon = null,
    iconPosition = "left",
    rounded = false,
    outlined = false,
    text = false,
    softShadow = true,
    pill = false,
    onClick = () => {},
    className = "",
    ...props
}) => {
    
    const getButtonClasses = () => {
        let classes = ["material-button"];
        
        // Add variant class
        if (outlined) {
            classes.push("outlined");
        } else if (text) {
            classes.push("text");
        } else {
            classes.push(variant);
        }
        
        // Add size class
        if (size !== "medium") {
            classes.push(size);
        }
        
        // Add modifier classes
        if (rounded) classes.push("rounded");
        if (pill) classes.push("pill");
        if (softShadow && !text && !outlined) classes.push("soft-shadow");
        if (loading) classes.push("loading");
        
        // Add custom className
        if (className) classes.push(className);
        
        return classes.join(" ");
    };

    const renderIcon = () => {
        if (loading) {
            return <span className="btn-spinner"></span>;
        }
        
        if (icon) {
            return (
                <i className={`${icon} btn-icon ${iconPosition === "right" ? "right" : ""}`}></i>
            );
        }
        
        return null;
    };

    const renderContent = () => {
        if (typeof children === "string") {
            return <span className='btn-text'>{children}</span>;
        }
        return children;
    };

    return (
        <button 
            type={type} 
            className={getButtonClasses()}
            disabled={disabled || loading}
            onClick={onClick}
            {...props}
        >
            {iconPosition === "left" && renderIcon()}
            {renderContent()}
            {iconPosition === "right" && renderIcon()}
        </button>
    );
};

export default MaterialButton;
